import { get } from "lodash";
import serverCall from "../serverCall";

const login = async (values) => {
  try {
    const { email, password } = values;
    const response = await serverCall.post(
      `/auth/admin/login?email=${email}&password=${password}`
    );

    const data = get(response, "data", null);

    if (data) {
      setDataToLocal(data);
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const getUser = async (productId, page, size, search) => {
  try {
    const response = await serverCall.get(
      `/users/get/expert?productId=${productId}&pageNumber=${page}&pageSize=${size}&search=${search}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
const getOfferCode = async (id) => {
  try {
    const response = await serverCall.get(`/promocode/`);
    return response;
  } catch (error) {
    throw error;
  }
};

const addOfferCode = async (promoCode, credit) => {
  try {
    const response = await serverCall.post(
      `/promocode/create?promoCode=${promoCode}&credit=${credit}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
const deleteOfferCode = async (id) => {
  try {
    const response = await serverCall.delete(`/promocode/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateOfferCode = async (id, promoCode, credit) => {
  try {
    const response = await serverCall.put(
      `/promocode/${id}?promoCodeName=${promoCode}&credit=${credit}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};


const setDataToLocal = (data) => {
  const email = data.apiresponse.data.email;
  const token = data.apiresponse.data.jwt;

  const userProfile = {
    token,
    email,
  };
  localStorage.setItem("watchcert_admin_store", JSON.stringify(userProfile));
};

const getReports = async (page, size, search) => {
  try {
    const response = await serverCall.get(
      `/watchdetails/admin/reports?pageNumber=${page}&pageSize=${size}&search=${search}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const AuthService = {
  login,
  getUser,
  getOfferCode,
  addOfferCode,
  deleteOfferCode,
  updateOfferCode,
  getReports,
};

export default AuthService;

